import apiClient from './apiClient';
import type { Entitlement, CreateEntitlementDto, UpdateEntitlementDto } from '../types/types';

const entitlementsService = {
    getAll: async (): Promise<Entitlement[]> => {
        const res = await apiClient.get<Entitlement[]>('/entitlements');
        return res.data;
    },

    getById: async (id: number): Promise<Entitlement> => {
        const res = await apiClient.get<Entitlement>(`/entitlements/${id}`);
        return res.data;
    },

    create: async (dto: CreateEntitlementDto): Promise<Entitlement> => {
        const res = await apiClient.post<Entitlement>('/entitlements', dto);
        return res.data;
    },

    update: async (id: number, dto: UpdateEntitlementDto): Promise<Entitlement> => {
        const res = await apiClient.patch<Entitlement>(`/entitlements/${id}`, dto);
        return res.data;
    },

    remove: async (id: number): Promise<{ message: string }> => {
        const res = await apiClient.delete<{ message: string }>(`/entitlements/${id}`);
        return res.data;
    },
};

export default entitlementsService;
